<template>
    <div>
        <eta-salle-info v-if="Object.keys(this.getSalleDetailed).length !== 0" :salle="getSalleDetailed"></eta-salle-info>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'EtaSalleInfoStore',
  props: {
    id: {
      type: String
    }
  },
  computed: {
    ...mapGetters('etablissements', [
      'getSalleDetailed'
    ])
  },
  methods: {
    ...mapActions('etablissements', [
      'retrieveSalle'
    ])
  },
  mounted () {
    if (Object.keys(this.getSalleDetailed).length === 0) {
      this.retrieveSalle(this.id)
    }
  }
}
</script>

<style>

</style>
